import React from 'react';
import { Layout, Space } from 'antd';
import Buttons from './Sections/Buttons';
import Selects from './Sections/Selects';
import Dropdowns from './Sections/Dropdowns';
import Inputs from './Sections/Radios';
import Switches from './Sections/Switches';
import Alerts from './Sections/Alerts';
import Tooltips from './Sections/Tooltips';
import Messages from './Sections/Messages';
import Checkboxes from './Sections/Checkboxes';
import Modals from './Sections/Modals';
import Tables from './Sections/Tables';
import Forms from './Sections/Forms';
import Tags from './Sections/Tags';
const { Header, Footer, Sider, Content } = Layout;

const headerStyle: React.CSSProperties = {
  textAlign: 'center',
  color: '#fff',
  height: 64,
  paddingInline: 50,
  lineHeight: '64px',
  backgroundColor: 'rgb(82, 91, 98)',
};

const contentStyle: React.CSSProperties = {
  textAlign: 'center',
  minHeight: 120,
  lineHeight: '120px',
  color: '#333',
  backgroundColor: 'rgb(245, 245, 245)',
  overflowY: 'scroll',
};

const siderStyle: React.CSSProperties = {
  textAlign: 'center',
  lineHeight: '120px',
  color: '#fff',
  backgroundColor: 'rgb(113, 130, 143)',
};

const footerStyle: React.CSSProperties = {
  textAlign: 'center',
  color: '#fff',
  backgroundColor: 'rgb(82, 91, 98)',
  padding: 10,
};


// This is not a productive use of dev time/effort

function Sandbox() {
  return (
    <Layout>
    <Header style={headerStyle}>Sandbox</Header>
    <Layout>
      <Sider style={siderStyle}>[placeholder]</Sider>
      <Content style={contentStyle}>
        <Space direction="vertical" size="large">
          <Buttons />
          <Selects />
          <Dropdowns />
          <Inputs />
          <Switches />
          <Alerts />
          <Tooltips />
          <Messages />
          <Checkboxes />
          <Modals />
          <Tables />
          <Forms />
          <Tags />
        </Space>
      </Content>
    </Layout>
    <Footer style={footerStyle}>--- render test ---</Footer>
  </Layout>
  )
}

export default Sandbox;
